import { clsx } from "clsx";
import type { SVGProps } from "react";
const SvgTravellerSelected = ({
  className,
  ...props
}: SVGProps<SVGSVGElement>) => {
  const mergedClassName = clsx("rtl:-scale-x-100", className);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden="true"
      className={mergedClassName}
      {...props}
    >
      <defs>
        <mask id="travellerSelected_svg__a">
          <path fill="#fff" d="M0 0h24v24H0z" />
          <circle cx={17.5} cy={17.5} r={6} fill="#000" />
        </mask>
      </defs>
      <g
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth={1.5}
        mask="url(#travellerSelected_svg__a)"
      >
        <path strokeLinecap="round" d="M14 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0" />
        <path d="M16 12.5c0-1.9 0-2.8-.6-3.4s-1.5-.6-3.4-.6-2.8 0-3.4.6-.6 1.5-.6 3.4V14c0 1 0 1.4.3 1.7s.8.3 1.7.3v4c0 1 0 1.4.3 1.7s.8.3 1.7.3c1 0 1.4 0 1.7-.3s.3-.8.3-1.7v-4c1 0 1.4 0 1.7-.3s.3-.8.3-1.7z" />
      </g>
      <path
        stroke="#4EA974"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.43}
        d="m20.42 15.67-3.54 3.7a.34.34 0 0 1-.5 0l-1.66-1.7"
      />
    </svg>
  );
};
export default SvgTravellerSelected;
